var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full flex items-center justify-center"},[_c('div',{staticClass:"shadow rounded border p-4 flex"},[_c('div',{staticStyle:{"width":"160px"}},[_c('div',[_vm._v("书签管理")])]),_c('div',{staticStyle:{"width":"640px"}})])])
}]

export { render, staticRenderFns }